import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';

import Main from './main';
import { marketsStore } from '../../../store/marketsStore';

const mainQuickBetsRow = ['top', 'Bottom'];

export const MainBetsWrapper = observer(() => {
  const t = useTranslation();
  const { mainMarketsData, selectedMarket, setSelectedMarket } = marketsStore;
  const { activeFreeBet } = freeBetStore;

  const mainTopRowData = mainMarketsData.slice(0, 3);

  const mainBottomRowData = mainMarketsData.slice(3);

  return (
    <div className='mid-block-btn'>
      <div className='mid-block-btn-row'>
        {mainQuickBetsRow.map((el) => (
          <Main
            t={t}
            key={el}
            activeFreeBet={activeFreeBet}
            selectedMarket={selectedMarket}
            mainMarketsData={el === 'top' ? mainTopRowData : mainBottomRowData}
            setSelectedMarket={setSelectedMarket}
          />
        ))}
      </div>
    </div>
  );
});
